import {
    differenceInCalendarDays,
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    format,
    isPast,
    isSameDay,
} from 'date-fns';
import { TFunction } from 'i18next';

export const renderDate = (inputDate: Date): string => {
    if (inputDate.toDateString() === 'Invalid Date') {
        return '';
    }
    const daysAway = differenceInCalendarDays(inputDate, new Date());

    if (daysAway === 0) {
        return format(inputDate, "'Today,' h:mm a");
    } else if (daysAway >= 1 && daysAway <= 6) {
        return format(inputDate, 'eee, h:mm a');
    } else {
        return `${format(inputDate, 'M/dd')}, ${format(inputDate, 'h:mm a')}`;
    }
};

export function formatPromoExpirationTime(dateString: string, t: TFunction<['promohub'], undefined>): string {
    const expirationDate: Date = new Date(dateString);
    const currentDate: Date = new Date();

    if (isPast(expirationDate)) {
        return t('expired');
    }

    const days: number = differenceInDays(expirationDate, currentDate);
    const hours: number = differenceInHours(expirationDate, currentDate);
    const minutes: number = differenceInMinutes(expirationDate, currentDate);

    if (days > 0) {
        return t('expires_days', { count: days });
    } else if (hours > 0) {
        return t('expires_hours', { count: hours });
    } else {
        return t('expires_minutes', { count: minutes });
    }
}

export const renderLongDayMonthDate = (inputDate: Date): string => {
    if (isNaN(inputDate.getTime())) {
        return '';
    }
    const today = new Date();
    if (isSameDay(today, inputDate)) {
        return 'Today';
    }

    return format(inputDate, 'EEEE, MMM do');
};

export const renderTime = (inputDate: Date): string => {
    if (isNaN(inputDate.getTime())) {
        return '';
    }

    return format(inputDate, 'h:mm a');
};
